/** @format */
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../assets/custom_styles.css";
import barchart from "../assets/img/Barchart.png";
import Treemap_chart from "../assets/img/Treemap_chart.png";
import piechart from "../assets/img/piechart.png";
import Select from "react-select";
import DataTable from "react-data-table-component";
import Piechart from "./datavisualization/Piechart";
import Treemapchart from "./datavisualization/Treemapchart";
import Barchart from "./datavisualization/Barchart";
import table_img from "../assets/img/table_img.png";
import HeaderWithTooltip from "./HeaderWithTooltip";

// Imports for export as pdf,csv,excel
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { exportToPDF } from "../components/datavisualization/exportUtils"; // Import the export function

/** Functions for export as pdf,csv and excel */
const exportToExcel = (
  data,
  title = "Exported Data",
  filename = "data",
  footNote = "",
) => {
  if (!data || data.length === 0) return;

  // 1. Extract headers
  const originalHeaders = Object.keys(data[0]);
  const headers = originalHeaders.map((h) => h.toUpperCase());

  // 2. Convert data to 2D array
  const rows = data.map((row) => originalHeaders.map((header) => row[header]));

  // 3. Combine title + headers + rows
  const aoa = [
    [title], // Title row
    [], // Spacer row (optional)
    headers, // Header row
    ...rows, // Data rows
    [],
    ["NOTE:"],
    [footNote],
  ];

  // 4. Create worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(aoa);

  // 5. Add merge for the title row across all columns
  worksheet["!merges"] = [
    {
      s: { r: 0, c: 0 }, // Start at A1
      e: { r: 0, c: headers.length - 1 }, // End at last column of row 1
    },
  ];

  // 6. Create workbook and export
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `${filename}.xlsx`);
};

// const exportToCSV = (data, filename = "data") => {
//   const worksheet = XLSX.utils.json_to_sheet(data);
//   const csv = XLSX.utils.sheet_to_csv(worksheet);
//   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//   saveAs(blob, `${filename}.csv`);
// };

const exportToCSV = (data, title, filename = "data", footNote = "") => {
  if (!data || data.length === 0) return;

  // 1️. Extract headers
  const originalHeaders = Object.keys(data[0]);
  const headers = originalHeaders.map((h) => {
    const upper = h.toUpperCase();
    //Convert to number pattern instead of date
    return /^\d+\s*-\s*\d+$/.test(upper) ? `\t${upper}` : upper;
  });
  // 2️. Create rows (same as Excel)
  const rows = data.map((row) => originalHeaders.map((header) => row[header]));

  // 3️. Combine title + headers + rows
  const aoa = [[title], [], headers, ...rows, [], ["NOTE:"], [footNote]];

  // 4️. Convert AOA to worksheet, then to CSV
  const worksheet = XLSX.utils.aoa_to_sheet(aoa);
  worksheet["!merges"] = [
    {
      s: { r: 0, c: 0 }, // Start at A1
      e: { r: 0, c: headers.length - 1 }, // End at last column of row 1
    },
  ];
  const csv = XLSX.utils.sheet_to_csv(worksheet);

  // 5️. Create and download CSV blob
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, `${filename}.csv`);
};
/*********************************************/

const numericColumnAccessors = new Set([
  "cases_count",
  "ASR",
  "cir",
  "cr",
  "cases_percentage",
]);

const getSortableValue = (value, isNumeric) => {
  if (!isNumeric) return value;

  if (value === null || value === undefined || value === "") {
    return Number.NEGATIVE_INFINITY;
  }

  if (typeof value === "number") {
    return value;
  }

  const normalized = String(value).replace(/,/g, "").trim();
  const parsedValue = Number.parseFloat(normalized.replace(/[%\s]/g, ""));

  return Number.isNaN(parsedValue) ? Number.NEGATIVE_INFINITY : parsedValue;
};

const compareSortableValues = (a, b, direction, isNumeric) => {
  if (!isNumeric) {
    return direction === "asc"
      ? String(a).localeCompare(String(b))
      : String(b).localeCompare(String(a));
  }

  const aValue = getSortableValue(a, true);
  const bValue = getSortableValue(b, true);

  if (aValue === bValue) return 0;
  return direction === "asc" ? aValue - bValue : bValue - aValue;
};

const Visualization = () => {
  const display = [
    { label: "By place", value: "population" },
    { label: "By cancer", value: "Cancer" },
    { label: "ASPR", value: "aspr" },
  ];
  const [selectedDisplay, setSelectedDisplay] = useState({
    label: "By place",
    value: "population",
  });
  const [cancerList, setCancerList] = useState([]);
  const [selectedCancers, setSelectedCancers] = useState([]);
  const genderOptions = [
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
    { value: "0", label: "Both" },
  ];
  const [selectedGenders, setSelectedGenders] = useState({
    value: "0",
    label: "both",
  });
  const [districtList, setDistrictList] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const fromAge = [
    { value: 0, label: "0 - 4" },
    { value: 5, label: "5 - 9" },
    { value: 10, label: "10 - 14" },
    { value: 15, label: "15 - 19" },
    { value: 20, label: "20 - 24" },
    { value: 25, label: "25 - 29" },
    { value: 30, label: "30 - 34" },
    { value: 35, label: "35 - 39" },
    { value: 40, label: "40 - 44" },
    { value: 45, label: "45 - 49" },
    { value: 50, label: "50 - 54" },
    { value: 55, label: "55 - 59" },
    { value: 60, label: "60 - 64" },
    { value: 65, label: "65 - 69" },
    { value: 70, label: "70 - 74" },
    { value: 75, label: "75+" },
  ];
  const toAge = [
    { value: 4, label: "0 - 4" },
    { value: 9, label: "5 - 9" },
    { value: 14, label: "10 - 14" },
    { value: 19, label: "15 - 19" },
    { value: 24, label: "20 - 24" },
    { value: 29, label: "25 - 29" },
    { value: 34, label: "30 - 34" },
    { value: 39, label: "35 - 39" },
    { value: 44, label: "40 - 44" },
    { value: 49, label: "45 - 49" },
    { value: 54, label: "50 - 54" },
    { value: 59, label: "55 - 59" },
    { value: 64, label: "60 - 64" },
    { value: 69, label: "65 - 69" },
    { value: 74, label: "70 - 74" },
    { value: 75, label: "75+" },
  ];
  const projectionYear = Number(sessionStorage.getItem("projection_year"));
  const maxProjectionYear = Number.isFinite(projectionYear)
    ? Math.max(2012, projectionYear)
    : 2021;
  const fromYearOptions = Array.from(
    { length: maxProjectionYear - 2012 + 1 },
    (_, index) => {
      const value = 2012 + index;
      return { value, label: value };
    },
  );
  const toYearOptions = Array.from(
    { length: maxProjectionYear - 2012 + 1 },
    (_, index) => {
      const value = 2012 + index;
      return { value, label: value };
    },
  );

  const [selectedFromAge, setSelectedFromAge] = useState({
    value: 0,
    label: 0,
  });
  const [selectedToAge, setSelectedToAge] = useState({
    value: 75,
    label: "75+",
  });
  const [selectedFromYear, setSelectedFromYear] = useState({
    value: 2012,
    label: 2012,
  });
  const [selectedToYear, setSelectedToYear] = useState({
    value: maxProjectionYear,
    label: maxProjectionYear,
  });
  const [showModal, setShowModal] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [tableData, setTableData] = useState("");
  const [title, setTitle] = useState("");
  const [subtitle1, setSubtitle1] = useState("");
  const [subtitle2, setSubtitle2] = useState("");
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]); //To set dynamic columns
  const [selectedChart, setSelectedChart] = useState(null);
  const [chartData, setChartData] = useState({});
  const [finalData, setFinalData] = useState([]);
  const [hasValidationError, setHasValidationError] = useState(false);
  const isNoData =
    !loading && !hasValidationError && (!finalData || finalData.length === 0);
  const [footNote, setFootNote] = useState("");

  // District footnote mapping - customize messages based on district ID
  const districtFootnoteMap = {
    1: " Chennai  \u2013   includes 155 divisions covering 170 km\u00B2",
    2: " Kanchipuram  \u2013  includes Chengalpattu district + part of GCC areas",
    3: " Tiruvallur \u2013  includes part of GCC areas",
    25: " Nagapattinam  \u2013  includes Mayiladuthurai district",
    4: " Viluppuram \u2013   includes Kallakurichi district",
    7: " Vellore \u2013  includes Ranipet and Tirupattur districts",
    27: " Tirunelveli \u2013  includes Tenkasi district",
  };

  // Function to generate dynamic footnote message based on selected districts
  // const generateFootnoteMessage = () => {
  //   if (!selectedDistricts || selectedDistricts.length === 0) {
  //     return "Old district boundaries as per 2011 census; Chennai \u2013  includes 155 divisions covering 170 km\u00B2 ; Kanchipuram  \u2013  includes Chengalpattu district + part of GCC areas; Tiruvallur \u2013 includes part of GCC areas; Nagapattinam  \u2013includes Mayiladuthurai district; Viluppuram  \u2013 includes Kallakurichi district; Vellore  \u2013 includes Ranipet and Tirupattur districts; Tirunelveli \u2013 includes Tenkasi district";
  //   }

  //   // Create a custom footnote based on selected districts
  //   // Only include districts that exist in the footnote map
  //   const customFootnotes = selectedDistricts
  //     .map((district) => {
  //       // Match by numeric ID (district_master_id) with the mapping
  //       const districtId = Number(district.id);
  //       // Return only if district ID exists in the map, otherwise return undefined
  //       return districtFootnoteMap[districtId];
  //     })
  //     .filter(Boolean); // Remove undefined values

  //   // Return combined footnotes or empty string if no districts in map
  //   return customFootnotes.length > 0 ? customFootnotes.join("; ") : "";
  // };
  const generateFootnoteMessage = () => {
    const prefix = "Old district boundaries as per 2011 census; ";

    if (!selectedDistricts || selectedDistricts.length === 0) {
      return prefix + Object.values(districtFootnoteMap).join("; ");
    }

    const customFootnotes = selectedDistricts
      .map((district) => {
        const districtId = Number(district.id);
        return districtFootnoteMap[districtId];
      })
      .filter(Boolean);

    return customFootnotes.length > 0
      ? prefix + customFootnotes.join("; ")
      : "";
  };
  const isBreastCancerSelected = () => {
    return selectedCancers.some((cancer) => Number(cancer.id) === 42);
  };
  const shouldShowDistrictFootnote = () => {
    // By Place is always district-related
    if (selectedDisplay?.value === "population") {
      return true;
    }

    // Cancer or ASPR -> show whenever one or more districts are selected
    if (
      (selectedDisplay?.value === "Cancer" ||
        selectedDisplay?.value === "aspr") &&
      selectedDistricts.length > 0
    ) {
      return true;
    }

    return false;
  };
  const shouldShowBreastNote = () => {
    if (selectedDisplay?.value === "aspr") {
      // return (
      //   selectedGenders?.value === "0" &&
      //   selectedCancers.length === 0 &&
      //   selectedDistricts.length > 0
      // );
      // 1. Gender = Both + All cancers
      // 2. Gender = Both + Breast cancer selected
      return (
        selectedGenders?.value === "0" &&
        (selectedCancers.length === 0 || isBreastCancerSelected())
      );
    } else if (selectedDisplay?.value === "Cancer") {
      // 1. Gender = Both + All cancers
      // 2. Gender = Both + Breast cancer selected
      return (
        selectedGenders?.value === "0" &&
        (selectedCancers.length === 0 || isBreastCancerSelected())
      );
    } else if (selectedDisplay?.value === "population") {
      // Only when breast cancer selected
      return selectedGenders?.value === "0" && isBreastCancerSelected();
    }

    return false;
  };
  const customStyles = {
    headRow: {
      style: {
        minHeight: "32px",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#007bff",
        color: "#fff",
        fontSize: "14px",
        fontWeight: "600",
        padding: "6px 10px",
        justifyContent: "center",
        textAlign: "center",
        border: "1px solid #dee2e6",
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        border: "1px  #dee2e6",
        borderStyle: "inset",
      },
    },
    conditionalRowStyles: [
      {
        when: (row) => row.isTotal,
        style: {
          fontWeight: "bold",
          backgroundColor: "#f0f0f0",
        },
      },
    ],
  };

  const onChangeFilter = () => {
    const cancerChange = selectedCancers
      .map((filterItem) => {
        const matchCancer = cancerList.find(
          (d) => d.value === filterItem.value,
        );
        const matchResult = matchCancer
          ? { name: filterItem.value, gender: matchCancer.gender }
          : null;
        return matchResult;
      })
      .filter(Boolean);

    let hasMale = false;
    let hasFemale = false;
    let hasBoth = false;

    for (const { name } of cancerChange) {
      const matchCancer = cancerList.find((d) => d.value === name);

      if (matchCancer) {
        const gender = Number(matchCancer.gender); // type conversion string into a number

        if (gender === 0) hasBoth = true;
        if (gender === 1) hasMale = true;
        if (gender === 2) hasFemale = true;
      }
    }
    let genderResult;
    if (hasBoth && hasMale && hasFemale) {
      genderResult = "Both"; // all present
    } else if (hasBoth && hasMale) {
      genderResult = "Male"; // 0 & 1
    } else if (hasBoth && hasFemale) {
      genderResult = "Female"; // 0 & 2
    } else if (hasMale && hasFemale) {
      genderResult = "Both"; //1 & 2
    } else if (hasMale) {
      genderResult = "Male"; // only 1
    } else if (hasFemale) {
      genderResult = "Female"; // only 2
    } else if (hasBoth) {
      genderResult = "Both"; // only 0
    } else {
      genderResult = "Both";
    }
    return genderResult;
  };
  const handleDisplayChange = (val) => {
    setSelectedDisplay(val);
  };
  const handleCancerChange = (val) => {
    setSelectedCancers(val || []);
    setSelectedGenders({
      value: "0",
      label: "Both",
    }); // reset gender filter
  };

  const handleGenderChange = (selectedGender) => {
    setSelectedGenders(selectedGender); //returns single Object
  };
  const handleFromAgeChange = (val) => {
    setSelectedFromAge(val);
    validateRange(val, selectedToAge, selectedFromYear, selectedToYear);
  };

  const handleToAgeChange = (val) => {
    setSelectedToAge(val);
    validateRange(selectedFromAge, val, selectedFromYear, selectedToYear);
  };

  const handleFromYearChange = (val) => {
    setSelectedFromYear(val);
    validateRange(selectedFromAge, selectedToAge, val, selectedToYear);
  };

  const handleToYearChange = (val) => {
    setSelectedToYear(val);
    validateRange(selectedFromAge, selectedToAge, selectedFromYear, val);
  };
  //Display dynamic gender based on selected CancerType
  useEffect(() => {
    const genderLabel = onChangeFilter(); // returns 'Male', 'Female', or 'Both'

    // Find the gender option that matches the label returned
    const selectedGenderOption = genderOptions.find(
      (opt) => opt.label === genderLabel,
    ) || { value: "0", label: "Both" };
    setSelectedGenders(selectedGenderOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCancers]);

  //Age and Year Range validation
  const validateRange = (
    selectedFromAge,
    selectedToAge,
    selectedFromYear,
    selectedToYear,
  ) => {
    if (
      selectedFromAge?.value !== undefined &&
      selectedToAge?.value !== undefined &&
      selectedFromAge.value > selectedToAge.value
    ) {
      setValidationMessage("From Age must be less than To Age.");
      setShowModal(true);
      setHasValidationError(true);
      setLoading(false);
      setFinalData([]);
      setColumns([]);

      return false;
    } else if (
      selectedFromYear?.value !== undefined &&
      selectedToYear?.value !== undefined &&
      selectedFromYear.value > selectedToYear.value
    ) {
      setValidationMessage("From Year must be less than or equal to To Year.");
      setShowModal(true);
      setHasValidationError(true);
      setLoading(false);
      setFinalData([]);
      setColumns([]);

      return false;
    }

    setShowModal(false);
    setHasValidationError(false);
    return true;
  };
  const fetchCancerAndDistrict = async () => {
    try {
      const [cancerList, districtList] = await Promise.all([
        // API Call: Display_CancerList
        // Purpose: Retrieves a list of all available cancer types from the database
        // Returns: Array of cancer objects containing cancer_master_id, cancer_code, cancer_name, and gender information
        // Used for: Populating the cancer type dropdown filter in the UI
        axios.get("Display_CancerList", { withCredentials: false }),
        // API Call: Display_DistrictList
        // Purpose: Retrieves a list of all available districts/geographical regions from the database
        // Returns: Array of district objects containing district_master_id and district_name
        // Used for: Populating the district/location dropdown filter in the UI
        axios.get("Display_DistrictList", { withCredentials: false }),
      ]);
      const allCancer = cancerList.data.cancer_list;
      const cancerType = allCancer.map((cancer) => ({
        id: cancer.cancer_master_id,
        label: `${cancer.cancer_code} - ${cancer.cancer_name}`,
        value: cancer.cancer_code,
        gender: cancer.gender,
      }));

      const allDistricts = districtList.data;
      const districts = allDistricts.map((district) => ({
        id: district.district_master_id,
        label: district.district_name,
        value: district.district_name,
      }));
      setCancerList(cancerType);
      setDistrictList(districts);
    } catch {}
  };
  useEffect(() => {
    fetchCancerAndDistrict();
    sessionStorage.setItem("visual_type", JSON.stringify("today"));
  }, []);
  useEffect(() => {
    let isMounted = true;

    // Prevent fetching data when validation rules are violated.
    // This ensures the UI doesn't show "no data" while the user is still correcting the input.
    const isValidRange = validateRange(
      selectedFromAge,
      selectedToAge,
      selectedFromYear,
      selectedToYear,
    );

    if (!isValidRange) {
      setLoading(false);
      return () => {
        isMounted = false;
      };
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        // const storedVisual = sessionStorage.getItem("visual_type");
        // let visualObj = null || "today";
        // if (storedVisual) {
        //   visualObj = JSON.parse(storedVisual);
        // }
        const analyticData = {
          district:
            selectedDistricts.length > 0
              ? selectedDistricts.map((d) => d.id)
              : "all",

          cancer_type:
            selectedCancers.length > 0
              ? selectedCancers.map((c) => c.id)
              : "all",

          gender:
            selectedGenders?.value === "1"
              ? 1
              : selectedGenders?.value === "2"
                ? 2
                : "both",

          from_age_range: selectedFromAge ? selectedFromAge.value : 0,
          to_age_range: selectedToAge ? selectedToAge.value : 75,

          from_year: selectedFromYear ? selectedFromYear.value : 2012,
          to_year: selectedToYear ? selectedToYear.value : maxProjectionYear,

          visual_type: "today",
          display_type: "table",
          visual_mode:
            selectedDisplay?.value === "population"
              ? "population"
              : selectedDisplay?.value === "Cancer"
                ? "Cancer"
                : selectedDisplay?.value === "aspr"
                  ? "aspr"
                  : null,
        };
        const display_type = selectedDisplay?.label || "Population";
        const gender = selectedGenders?.label || "Both";
        const fromAge = selectedFromAge?.value || 0;
        const toAge =
          selectedToAge?.value === 75 ? "75+" : selectedToAge?.value || "75+";
        const fromYear = selectedFromYear?.value || 2012;
        const toYear = selectedToYear?.value || maxProjectionYear;
        setTitle(
          `Frequency of cases, incidence rates and cumulative risk  ${display_type}, Gender is ${gender} and age group ${fromAge} - ${toAge}, from ${fromYear} to ${toYear}`,
        );

        const cancerNames = selectedCancers
          .map((c) => c.label || c.name)
          .join(", ");
        const districtNames = selectedDistricts
          .map((d) => d.label || d.name)
          .join(", ");

        setSubtitle1(cancerNames || "All Cancer Types");
        setSubtitle2(districtNames || "All Districts");
        const token = sessionStorage.getItem("token");
        // API Call: /getAnalyticalData
        // Purpose: Fetches analytical cancer data based on user-selected filters (cancer type, district, gender, age range, year range)
        // Method: POST (sends filter criteria to the server)
        // Parameters: analyticData object containing district, cancer_type, gender, age range, year range, visual_type, display_type, visual_mode
        // Returns: Processed analytical data including case counts, ASR (Age Standardized Rate), CIR (Crude Incidence Rate), CR (Cumulative Risk)
        // Authentication: Uses Bearer token from session storage for secure access
        // Used for: Populating charts, tables, and visualizations with filtered cancer incidence data
        const AnalyticalDataRes = await axios.post(
          "/getAnalyticalData",
          analyticData,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Send token in headers
              "Content-Type": "application/json",
            },
          },
        );
        const responseData = AnalyticalDataRes.data;
        const displayColumnMap = {
          population: [
            {
              header: "Residence District",
              accessor: "district",
              align: "left",
            },
            {
              header: "No. of Cases",
              accessor: "cases_count",
              align: "right",
            },
            {
              header: "ASR",
              fullText: "Age standardized rate (ASR/10⁵)",
              accessor: "ASR",
              align: "right",
            },
            {
              header: "CIR",
              fullText: "Crude incidence rate (CIR/10⁵)",
              accessor: "cir",
              align: "right",
            },
            {
              header: "CR",
              fullText: "Cumulative risk% (CR%)",
              accessor: "cr",
              align: "right",
            },
          ],
          Cancer: [
            {
              header: "Site of Cancer Name",
              accessor: "cancer",
              align: "left",
            },
            {
              header: "No. of Cases",
              accessor: "cases_count",
              align: "right",
            },
            {
              header: "ASR",
              fullText: "Age standardized rate (ASR/10⁵)",
              accessor: "ASR",
              align: "right",
            },
            {
              header: "CIR",
              fullText: "Crude incidence rate (CIR/10⁵)",
              accessor: "cir",
              align: "right",
            },
            {
              header: "CR",
              fullText: "Cumulative risk% (CR%)",
              accessor: "cr",
              align: "right",
            },
          ],
        };
        let finalColumns = [];
        let formattedData = [];

        if (selectedDisplay?.value === "aspr") {
          //  ASPR  columns
          const asprCancerColumns = [
            // accessor is value
            {
              header: "Code",
              accessor: "cancer_code",
              align: "left",
            },
            {
              header: "Site",
              accessor: "cancer",
              align: "left",
              width: "100%",
            },
            {
              header: "Cases",
              accessor: "cases_count",
              align: "right",
            },
            {
              header: "%",
              accessor: "cases_percentage",
              align: "right",
            },
          ].map((col) => ({
            // name: col.header,
            name: col.exportHeader ? (
              <HeaderWithTooltip
                fullText={col.exportHeader}
                shortText={col.header}
              />
            ) : (
              col.header
            ),
            selector: (row) => {
              const value = row[col.accessor];
              return getSortableValue(
                value,
                numericColumnAccessors.has(col.accessor),
              );
            },
            sortable: true,
            sortFunction: (rowA, rowB, direction) =>
              compareSortableValues(
                rowA[col.accessor],
                rowB[col.accessor],
                direction,
                numericColumnAccessors.has(col.accessor),
              ),
            cell: (row) => (
              <div style={{ textAlign: col.align || "left", width: "100%" }}>
                {row[col.accessor]}
              </div>
            ),
          }));

          const asprColumns = [
            {
              header: "ASR",
              fullText: "Age standardized rate (ASR/10⁵)",
              accessor: "ASR",
              align: "right",
            },
            {
              header: "CIR",
              fullText: "Crude incidence rate (CIR/10⁵)",
              accessor: "cir",
              align: "right",
            },
            {
              header: "CR",
              fullText: "Cumulative risk% (CR%)",
              accessor: "cr",
              align: "right",
            },
          ].map((col) => ({
            // name: col.header,
            name: col.exportHeader ? (
              <HeaderWithTooltip
                fullText={col.exportHeader}
                shortText={col.header}
              />
            ) : (
              col.header
            ),
            selector: (row) => {
              const value = row[col.accessor];
              return getSortableValue(
                value,
                numericColumnAccessors.has(col.accessor),
              );
            },
            sortable: true,
            sortFunction: (rowA, rowB, direction) =>
              compareSortableValues(
                rowA[col.accessor],
                rowB[col.accessor],
                direction,
                numericColumnAccessors.has(col.accessor),
              ),
            cell: (row) => (
              <div style={{ textAlign: col.align || "left", width: "100%" }}>
                {row[col.accessor]}
              </div>
            ),
          }));
          //  dynamic age group columns
          const dynamicKeys = Object.keys(responseData.data[0] || {});
          const ageKeys = dynamicKeys.filter((key) =>
            /^\d{1,2}-\d{1,2}$|^75-plus$/.test(key),
          );

          const getAlignment = (key) => {
            return /^\d{1,2}-\d{1,2}$|^75-plus$/.test(key) ? "right" : "left";
          };
          const ageColumns = ageKeys.map((key) => ({
            name: key,
            selector: (row) => getSortableValue(row[key], true),
            sortable: true,
            sortFunction: (rowA, rowB, direction) =>
              compareSortableValues(rowA[key], rowB[key], direction, true),
            cell: (row) => {
              // Format age group column values to one decimal place
              const value = row[key];
              // Only format if value is a number or can be parsed as a number
              const formatted =
                value !== undefined && !isNaN(parseFloat(value))
                  ? Number(parseFloat(value)).toFixed(1)
                  : value;
              return (
                <div style={{ textAlign: getAlignment(key), width: "100%" }}>
                  {formatted}
                </div>
              );
            },
          }));

          // Combine final columns
          finalColumns = [...asprCancerColumns, ...ageColumns, ...asprColumns];
          // Format data
          formattedData = responseData.data.map((item) => ({
            cancer_code: item.cancer_code,
            cancer: item.cancer,
            cases_count: item.cases_count,
            cases_percentage: item.cases_percentage,
            ASR: item.ASR,
            cir: item.cir,
            cr: item.cumulative_risk,
            ...ageKeys.reduce((acc, key) => {
              acc[key] = item[key];
              return acc;
            }, {}),
          }));
        } else {
          // For population or cancer
          finalColumns = (displayColumnMap[selectedDisplay?.value] || []).map(
            (col) => ({
              // name: col.header,
              // name: col.exportHeader ? (
              //   <HeaderWithTooltip
              //     fullText={col.exportHeader}
              //     shortText={col.header}
              //   />
              // ) : (
              //   col.header
              // ),
              // exportHeader: col.exportHeader || col.header,
              name: col.fullText ? (
                <HeaderWithTooltip
                  fullText={col.fullText}
                  shortText={col.header}
                />
              ) : (
                col.header
              ),
              exportHeader: col.header,
              selector: (row) => {
                const value = row[col.accessor];
                return getSortableValue(
                  value,
                  numericColumnAccessors.has(col.accessor),
                );
              },
              sortable: true,
              sortFunction: (rowA, rowB, direction) =>
                compareSortableValues(
                  rowA[col.accessor],
                  rowB[col.accessor],
                  direction,
                  numericColumnAccessors.has(col.accessor),
                ),
              cell: (row) => (
                <div style={{ textAlign: col.align || "left", width: "100%" }}>
                  {row[col.accessor]}
                </div>
              ),
            }),
          );

          // Format data for population and cancer
          formattedData = responseData.data.map((item) => {
            if (selectedDisplay?.value === "population") {
              return {
                district: item.district,
                cases_count: item.cases_count,
                ASR: item.ASR,
                cir: item.cir,
                cr: item.cumulative_risk,
              };
            } else {
              return {
                cancer: item.cancer,
                cases_count: item.cases_count,
                ASR: item.ASR,
                cir: item.cir,
                cr: item.cumulative_risk,
              };
            }
          });
        }

        //get the Numeric Columns
        const getNumericKeys = (data) => {
          if (!data || data.length === 0) return []; //checks the data is null or undefined
          const firstRow = data[0]; //It takes first array of objects(i.e key and value) in the data
          return Object.keys(firstRow).filter(
            (key) =>
              typeof firstRow[key] === "number" || //Compare the key that matches the datatype to number
              !isNaN(parseFloat(firstRow[key])),
          );
        };
        const roundToDecimals = (value, decimals = 1) => {
          return Number(parseFloat(value).toFixed(decimals));
        };

        // Sum the Numeric Columns
        const calculateTotals = (data, numericKeys) => {
          const totals = {};
          numericKeys.forEach((key) => {
            const sum = data.reduce((total, row) => {
              const val = parseFloat(row[key]);
              return total + (isNaN(val) ? 0 : val);
            }, 0);
            const decimals = key === "cr" ? 3 : 1;
            totals[key] = roundToDecimals(sum, decimals);
          });
          return totals;
        };

        const formatTotalsRow = (totals, displayType, backendTotals = {}) => {
          // Use backend totals if provided
          if (
            displayType === "population" ||
            displayType === "Cancer" ||
            displayType === "aspr"
          ) {
            const row =
              displayType === "population"
                ? { district: "Total", ...totals }
                : { cancer: "Total", ...totals };

            // If backend totals exist, override ASR, CIR, CR
            if (backendTotals) {
              if (backendTotals.total_asr !== undefined)
                row.ASR = backendTotals.total_asr;
              if (backendTotals.total_cir !== undefined)
                row.cir = backendTotals.total_cir;
              if (backendTotals.total_cr !== undefined)
                row.cr = backendTotals.total_cr;
            }
            return row;
          }
          return { label: "Total", ...totals };
        };
        //Append Total rows to table data
        const numericKeys = getNumericKeys(formattedData);
        const totals = calculateTotals(formattedData, numericKeys);

        // --- Use backend totals for ASR, CIR, CR ---
        const backendTotals = {
          total_asr: responseData.total_asr,
          total_cir: responseData.total_cir,
          total_cr: responseData.total_cr,
        };
        const totalsRow = formatTotalsRow(
          totals,
          selectedDisplay.value,
          backendTotals,
        );

        const chartDetails = responseData.chartData;
        const shouldHideTotalRow =
          selectedDisplay?.value === "Cancer" && selectedGenders?.value === "0";

        const fullData =
          selectedDisplay?.value === "population" ||
          selectedDisplay?.value === "aspr" ||
          shouldHideTotalRow
            ? [...formattedData]
            : [...formattedData, totalsRow];
        // const fullData =
        //   selectedDisplay?.value === "population" ||
        //   selectedDisplay?.value === "aspr"
        //     ? [...formattedData]
        //     : [...formattedData, totalsRow];
        if (isMounted) {
          setTableData(formattedData);
          setColumns(finalColumns);
          setChartData(chartDetails);
          setFinalData(fullData);
          setLoading(false);
        }
      } catch (error) {
      } finally {
        // setLoading(false);
      }
    };
    const debounceTimer = setTimeout(() => {
      fetchData();
    }, 500); // 500ms delay

    return () => {
      isMounted = false;
      clearTimeout(debounceTimer);
    };
  }, [
    selectedDisplay,
    selectedCancers,
    selectedGenders,
    selectedDistricts,
    selectedFromAge,
    selectedToAge,
    selectedFromYear,
    selectedToYear,
    maxProjectionYear,
  ]);
  // Logs user activity to the server.
  const logUserActivity = async (type, title, cancer, district) => {
    const token = sessionStorage.getItem("token");
    if (!token) return;
    try {
      // API Call: /log-activity
      // Purpose: Logs user interactions and activities on the platform for audit and analytics purposes
      // Method: POST (sends user activity data to the server)
      // Parameters: type (activity type), title (visualization/page title), cancer (selected cancer types), district (selected districts)
      // Returns: Confirmation of logged activity
      // Authentication: Uses Bearer token from session storage for secure access
      // Used for: Tracking user behavior, generating activity reports, and monitoring platform usage
      axios.post(
        "/log-activity",
        { type, title, cancer, district },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Send token in headers
            "Content-Type": "application/json",
          },
        },
      );
    } catch (error) {}
  };
  useEffect(() => {
    // const footnoteMessage = generateFootnoteMessage();
    const districtFootnote = shouldShowDistrictFootnote()
      ? generateFootnoteMessage()
      : "";
    if (shouldShowBreastNote()) {
      const additionalMessage = "Breast Cancer for male is excluded";
      setFootNote(
        districtFootnote
          ? `${districtFootnote}; <br><strong>${additionalMessage}</strong>`
          : `<strong>${additionalMessage}</strong>`,
      );
    } else {
      setFootNote(districtFootnote);
    }
  }, [selectedDisplay, selectedDistricts, selectedGenders, selectedCancers]);
  const exportFootNote = footNote
    ?.replace(/<br\s*\/?>/gi, "\n")
    ?.replace(/<[^>]*>/g, "");
  return (
    <div className="container">
      <div className="row mt-3 h-100">
        {/* //Filter Design */}
        <div className="col-12 col-md-4 col-lg-4 mb-3">
          <div className="sticky-filters ">
            <div
              className="shadow pt-1 mb-2 bg-white rounded-4 d-flex align-items-center justify-content-evenly"
              style={{ boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)" }}
            >
              {selectedDisplay?.value !== "aspr" && (
                <>
                  <img
                    className={`chart-icon px-2 py-2 ${
                      selectedChart === "bar" ? "active" : ""
                    }`}
                    src={barchart}
                    alt="Barchart"
                    onClick={() => setSelectedChart("bar")}
                  />
                  <img
                    className={`chart-icon px-2 py-2 ${
                      selectedChart === "tree" ? "active" : ""
                    }`}
                    src={Treemap_chart}
                    alt="Treemap_chart"
                    onClick={() => setSelectedChart("tree")}
                  />
                  <img
                    className={`chart-icon px-2 py-2 ${
                      selectedChart === "pie" ? "active" : ""
                    }`}
                    src={piechart}
                    alt="Piechart"
                    onClick={() => setSelectedChart("pie")}
                  />
                </>
              )}

              {/* Always show table button */}
              <img
                className={`chart-icon px-2 py-2 ${
                  selectedChart === "table" ? "active" : ""
                }`}
                src={table_img}
                alt="Table"
                onClick={() => setSelectedChart("table")}
              />
            </div>

            <div>
              <div className="shadow pt-4 px-4 pb-2 mb-2 bg-white rounded-4">
                <div className="row align-items-left">
                  <p className="col-12 fs-4">Recent Cancer Incidence Data</p>
                </div>
                <form>
                  <div className="mb-3">
                    <label id="display" className="mb-2">
                      Select
                    </label>
                    <div>
                      <Select
                        type="checkbox"
                        aria-labelledby="display"
                        options={display}
                        value={selectedDisplay}
                        onChange={handleDisplayChange}
                        closeMenuOnSelect={true}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="--Select--"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label id="Cancer_type" className="mb-2">
                      Site of Cancer
                    </label>
                    <div>
                      <Select
                        isMulti
                        aria-labelledby="Cancer_type"
                        options={cancerList}
                        value={selectedCancers}
                        onChange={handleCancerChange}
                        closeMenuOnSelect={true}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="All Cancers Together"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label id="Gender" className="mb-2">
                      Gender
                    </label>
                    <div>
                      <Select
                        aria-labelledby="Gender"
                        options={genderOptions}
                        value={selectedGenders}
                        onChange={handleGenderChange}
                        closeMenuOnSelect={true}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="--Select--"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label id="district_name" className="mb-2">
                      Residence District
                    </label>
                    <div>
                      <Select
                        isMulti
                        aria-labelledby="district_name"
                        options={districtList}
                        value={selectedDistricts}
                        onChange={setSelectedDistricts}
                        closeMenuOnSelect={true}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="All districts together"
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label id="age_group" className="form-label mb-2">
                      Age at Diagnosis
                    </label>
                    <div className="row ">
                      <Select
                        className="col-6"
                        aria-labelledby="age_group"
                        options={fromAge}
                        value={selectedFromAge}
                        onChange={handleFromAgeChange}
                        placeholder="From"
                      />
                      <Select
                        className="col-6"
                        aria-labelledby="age_group"
                        options={toAge}
                        value={selectedToAge}
                        onChange={handleToAgeChange}
                        placeholder="To"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label id="Period" className="mb-2">
                      Year of Diagnosis
                    </label>
                    <div className="row">
                      <Select
                        className="col-6"
                        aria-labelledby="Period"
                        options={fromYearOptions}
                        value={selectedFromYear}
                        onChange={handleFromYearChange}
                        placeholder="From"
                      />
                      <Select
                        className="col-6"
                        aria-labelledby="Period"
                        options={toYearOptions}
                        value={selectedToYear}
                        onChange={handleToYearChange}
                        placeholder="To"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Renders Dynamic Chart */}
        <div className="col-12 col-md-8 col-lg-8 content-scroll">
          <h2 className="text-center fs-4 mb-3 text-primary">{title}</h2>
          <h6 className="text-center fs-5 mb-3 text-primary">{subtitle1}</h6>
          <h6 className="text-center fs-5 mb-3 text-primary">{subtitle2}</h6>
          {showModal && (
            <div className="modal show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title"> Error!</h5>
                  </div>
                  <div className="modal-body">
                    <p>{validationMessage}</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {hasValidationError || isNoData ? (
            <div className="text-center mt-5 text-muted">
              <p className="fs-5">No data found</p>
            </div>
          ) : (
            <>
              {!selectedChart && (
                <div>
                  {loading ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border center text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    // Export Buttons
                    <div>
                      <div className="d-flex justify-content-end mb-3">
                        <button
                          className="btn btn-outline-success me-2"
                          // onClick={() =>
                          //   exportToExcel(
                          //     tableData,
                          //     title,
                          //     "tncrp_visualizationdata"
                          //   )
                          // }
                          onClick={async () => {
                            await logUserActivity(
                              "downloads",
                              `EXCEL export initiated for ${title}`,
                              subtitle1,
                              subtitle2,
                            );
                            exportToExcel(
                              tableData,
                              title,
                              "tncrp_visualizationdata",
                              exportFootNote,
                            );
                          }}
                        >
                          <i className="bi bi-file-earmark-excel me-1"></i>
                        </button>

                        <button
                          className="btn btn-outline-primary me-2"
                          // onClick={() => exportToCSV(tableData)}
                          onClick={async () => {
                            await logUserActivity(
                              "downloads",
                              `CVS export initiated for ${title}`,
                              subtitle1,
                              subtitle2,
                            );
                            exportToCSV(
                              tableData,
                              title,
                              "tncrp_visualizationdata",
                              exportFootNote,
                            );
                          }}
                          title="Export as CSV"
                        >
                          <i className="bi bi-file-earmark-text"></i>
                        </button>
                        <button
                          className="btn btn-outline-danger"
                          onClick={() =>
                            exportToPDF(
                              tableData,
                              columns,
                              // title,
                              // subtitle1,
                              // subtitle2,
                              selectedGenders?.label,
                              selectedDisplay?.value,
                              exportFootNote,
                            )
                          }
                          title="Export as PDF"
                        >
                          <i className="bi bi-file-earmark-pdf me-1"></i>
                        </button>
                      </div>
                      <DataTable
                        columns={columns}
                        data={finalData}
                        customStyles={customStyles}
                        fixedHeader // freezes the header
                        fixedHeaderScrollHeight="600px" //table body scroll area height
                        pagination
                        paginationPerPage={100}
                        highlightOnHover
                        dense
                        striped
                        responsive
                      ></DataTable>
                      {footNote && (
                        <>
                          <p dangerouslySetInnerHTML={{ __html: footNote }}></p>
                          <p>NOTE:</p>
                          <p className="fw-bold">
                            ASR-Age Standardized Rate (ASR/10⁵)
                          </p>
                          <p className="fw-bold">
                            CIR-Crude Incidence Rate (CIR/10⁵)
                          </p>
                          <p className="fw-bold">CR-Cumulative Risk% (CR%)</p>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
              {selectedChart === "table" && (
                <div>
                  {loading ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border center text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    // Export Buttons
                    <div>
                      <div className="d-flex justify-content-end mb-3">
                        <button
                          className="btn btn-outline-success me-2"
                          onClick={async () => {
                            await logUserActivity(
                              "downloads",
                              `EXCEL export initiated for ${title}`,
                              subtitle1,
                              subtitle2,
                            );
                            exportToExcel(
                              tableData,
                              title,
                              "tncrp_visualizationdata",
                              exportFootNote,
                            );
                          }}
                        >
                          <i className="bi bi-file-earmark-excel me-1"></i>
                        </button>

                        <button
                          className="btn btn-outline-primary me-2"
                          onClick={async () => {
                            await logUserActivity(
                              "downloads",
                              `CVS export initiated for ${title}`,
                              subtitle1,
                              subtitle2,
                            );
                            exportToCSV(
                              tableData,
                              title,
                              "tncrp_visualizationdata",
                              exportFootNote,
                            );
                          }}
                          title="Export as CSV"
                        >
                          <i className="bi bi-file-earmark-text"></i>
                        </button>

                        <button
                          className="btn btn-outline-danger"
                          onClick={() =>
                            exportToPDF(
                              tableData,
                              columns,
                              // title,
                              // subtitle1,
                              // subtitle2,
                              selectedGenders?.label,
                              selectedDisplay?.value,
                              exportFootNote,
                            )
                          }
                          title="Export as PDF"
                        >
                          <i className="bi bi-file-earmark-pdf me-1"></i>
                        </button>
                      </div>
                      <DataTable
                        columns={columns}
                        data={finalData}
                        customStyles={customStyles}
                        fixedHeader // freezes the header
                        fixedHeaderScrollHeight="600px" //table body scroll area height
                        pagination
                        paginationPerPage={100}
                        highlightOnHover
                        dense
                        striped
                        responsive
                      ></DataTable>
                      {footNote && (
                        <>
                          <p dangerouslySetInnerHTML={{ __html: footNote }}></p>
                          <p>NOTE:</p>
                          <p className="fw-bold">
                            ASR-Age Standardized Rate (ASR/10⁵)
                          </p>
                          <p className="fw-bold">
                            CIR-Crude Incidence Rate (CIR/10⁵)
                          </p>
                          <p className="fw-bold">CR-Cumulative Risk% (CR%)</p>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
              {selectedChart === "bar" && (
                <>
                  {hasValidationError ? (
                    <div className="text-center mt-5 text-muted">
                      <p className="fs-5">No data found</p>
                    </div>
                  ) : loading ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border center text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <Barchart
                      chartdata={chartData}
                      displaychart={selectedDisplay}
                    />
                  )}
                </>
              )}
              {selectedChart === "pie" && (
                <>
                  {hasValidationError ? (
                    <div className="text-center mt-5 text-muted">
                      <p className="fs-5">No data found</p>
                    </div>
                  ) : loading ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border center text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <Piechart
                      chartdata={chartData}
                      displaychart={selectedDisplay}
                    />
                  )}
                </>
              )}
              {selectedChart === "tree" && (
                <>
                  {hasValidationError ? (
                    <div className="text-center mt-5 text-muted">
                      <p className="fs-5">No data found</p>
                    </div>
                  ) : loading ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border center text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <Treemapchart
                      chartdata={chartData}
                      displaychart={selectedDisplay}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Visualization;
